module.exports = __webpack_public_path__ + "static/img/design-samsung-thumb.335b265.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/design-samsung-thumb.jpg
// module id = euTR
// module chunks = 0